import React, { useState, useRef, useCallback } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import LongFormDialog from '../../../components/Dialog/LongFormDialog'
import { useMoldInspectionReport } from '../../../reactQuery/job';
import { updateMoldInspectionData } from '../../../sevices/jobApi';
import Mold from '../../../components/Mold';
import Actions from '../../../components/Mold/Actions';

function MoldReport({ violation_id, job_id, buildingData, apartmentNumber, moldType, ticketData }) {
  const [anchorEl, setAnchorEl] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const [formData, setFormData] = useState(null)
  const formRef = useRef(null)

  const handleClose = useCallback(() => {
    setAnchorEl(false)
    setIsEditMode(false)
    setFormData(null)
  }, [])

  const handleClick = useCallback(() => {
    setAnchorEl(true)
  }, [])

  const handleEditModeChange = useCallback((editMode) => {
    setIsEditMode(editMode)
  }, [])

  const handleDataChange = useCallback((data) => {
    setFormData(data)
  }, [])

  const { isLoading, error, data, isError, refetch } = useMoldInspectionReport(job_id);
  const {data: reportData, inspector_certificate: inspectorCertificate,inspector_license: inspectorLicense} = data?.data || {};

  const queryClient = useQueryClient();

  const { mutate: updateMoldData, isPending: isUpdating } = useMutation({
    mutationFn: (data) => updateMoldInspectionData({ job_id, data }),
    onSuccess: (res) => {
      toast.success(res?.data?.message || 'Mold inspection data updated successfully');
      queryClient.invalidateQueries({ queryKey: ['mold-inspection-report', job_id] });
      refetch();
      setIsEditMode(false);
    },
    onError: (error) => {
      console.error('Error updating mold inspection data:', error);
      toast.error(error?.response?.data?.message || 'Failed to update mold inspection data');
    },
  });

  const handleSave = useCallback(() => {
    // Trigger form submission
    if (formRef.current) {
      formRef.current.requestSubmit()
    }
  }, [])

  const handleFormSubmit = useCallback((data) => {
    console.log('Saving data:', data)
    updateMoldData(data)
  }, [updateMoldData])

  const handleCancel = useCallback(() => {
    setFormData(null)
  }, [])

  console.log(reportData);

  return (
    <div>
      {anchorEl && (
        <LongFormDialog
          open={anchorEl}
          handleClose={handleClose}
          title={'MOLD ASSESSMENT AND REMEDIATION WORK PLAN'}
          btnTitle={'Confirm'}
          IsChildren={
            <Actions
              isEditMode={isEditMode}
              onEditModeChange={handleEditModeChange}
              onSave={handleSave}
              onCancel={handleCancel}
              isSaving={isUpdating}
              data={reportData}
              buildingData={buildingData}
              apartmentNumber={apartmentNumber}
              moldType={moldType}
              inspectorCertificate={inspectorCertificate}
              inspectorLicense={inspectorLicense}
              ticketData={ticketData}
            />
          }
        >
          <Mold
            data={reportData}
            violation_id={violation_id}
            isEditMode={isEditMode}
            onDataChange={handleDataChange}
            onSubmit={handleFormSubmit}
            formRef={formRef}
            buildingData={buildingData}
            apartmentNumber={apartmentNumber}
            inspectorCertificate={inspectorCertificate}
            moldType={moldType}
            ticketData={ticketData}
          />
        </LongFormDialog>
      )}
      <span className="underline orange-color" onClick={handleClick}>
        View Inspector Report
      </span>
    </div>
  )
}

export default MoldReport